// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('base.deliveryplanningtemplates', {
        url: '/deliveryplanningtemplates?searchTerm',
        views: {
            'baseList': {
            templateUrl: 'main/base/deliveryplanningtemplates/deliveryplanningtemplates.tpl.html',
            controller: 'DeliveryPlanningTemplatesController as vm'
        }},
        resolve: {
            deliveryplanningtemplates: deliveryplanningtemplatesResolver,
            searchTerm: searchTermResolver
        }
    });
}

// @ngInject
function deliveryplanningtemplatesResolver(DeliveryPlanningTemplatesApiService, $stateParams) {
    return DeliveryPlanningTemplatesApiService.getDeliveryPlanningTemplates({ page: 0, searchTerm:$stateParams.searchTerm, pageSize:null});
}
// @ngInject
function searchTermResolver($stateParams) {
    return $stateParams.searchTerm;
}
// @ngInject
function DeliveryPlanningTemplatesController($rootScope, $state, $scope, deliveryplanningtemplates, DeliveryPlanningTemplatesApiService, loadSpinnerService, searchTerm){
    var vm = this;

    vm.currentUser = $rootScope.currentUser;

    vm.deliveryplanningtemplates = deliveryplanningtemplates;
    vm.selectedDeliveryPlanningTemplateId = 0;
    vm.searchTerm = (searchTerm)? searchTerm : '';
    vm.currentPage = 1;

    vm.searchTermChange = searchTermChange;

    activate();

    function activate() {
        $scope.$watch(function(){return $state.params.deliveryPlanningTemplateId;}, function(newValue, oldValue){
            vm.selectedDeliveryPlanningTemplateId = parseInt($state.params.deliveryPlanningTemplateId,10);
        });
        $rootScope.$on('DeliveryPlanningTemplate.Inserted', function(event, response){
        });
        $rootScope.$on('DeliveryPlanningTemplate.Updated', function(event, response){
        });
        $rootScope.$on('DeliveryPlanningTemplate.Deleted', function(event, response){
        });
        $rootScope.$on('DeliveryPlanningTemplate.Changed', function(event, response){
            loadDeliveryPlanningTemplates();
        });
    }

    function loadDeliveryPlanningTemplates() {
        loadSpinnerService.start('mainSpinner');
        var request = { page: (vm.currentPage - 1), searchTerm:vm.searchTerm, pageSize:vm.itemsPerPage};
        DeliveryPlanningTemplatesApiService.getDeliveryPlanningTemplates(request).then(function(response){
            vm.deliveryplanningtemplates = response;
        }).finally(function(){
            loadSpinnerService.stop('mainSpinner', {force: true});
        });
    }
    
    function searchTermChange() {
        vm.currentPage = 1;
        loadDeliveryPlanningTemplates();
    }
}

angular
    .module('base.deliveryplanningtemplates', ['deliveryplanningtemplates.api', 'deliveryplanningtemplates.deliveryplanningtemplate'])
    .config(stateConfig)
    .controller('DeliveryPlanningTemplatesController', DeliveryPlanningTemplatesController);